<template>
  <div class="news">
    <NavBar />
    <b-container-fluid class="p-5">
      <h2 style="padding-top: 60px">Noticias Regeneración de Ecosistemas</h2>
      <hr />
      <div
        class="fb-page"
        data-href="https://www.facebook.com/regeneracionoceanos"
        data-tabs="timeline"
        data-width="1000"
        data-height=""
        data-small-header="false"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-show-facepile="true"
      >
        <blockquote
          cite="https://www.facebook.com/regeneracionoceanos"
          class="fb-xfbml-parse-ignore"
        >
          <a href="https://www.facebook.com/regeneracionoceanos">Facebook</a>
        </blockquote>
      </div>
    </b-container-fluid>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "News",
  data: function () {
    return {
    };
  },
  mounted: function () {
    if (typeof FB === "undefined") {
        this.fbInit();
    } else {
        window.FB.XFBML.parse();
    }
  },
  components: {},
  methods: {
    fbInit() {
        window.fbAsyncInit = function() {
            FB.init({
                appId: "198038468947391",
                autoLogAppEvents: true,
                xfbml: true,
                version: "v8.0"
            });
            FB.AppEvents.logPageView();
        };
        (function(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/fi_FI/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    }
  },
};
</script>

<style lang="scss" scoped>
.news {
  color: black;
}
.subtitle {
  color: rgb(122, 120, 120);
}
.navbar {
  background-color: white !important;

  color: black;
}

.titulo {
  text-align: left;
}

.image {
  padding-top: 5%;
  max-height: 60%;
}

::v-deep .nav-link {
  color: rgba($color: black, $alpha: 1) !important;
}
hr {
  border: 0.1px solid rgb(150, 149, 149);
  background: rgb(150, 149, 149);
  width: 88%;
}
p {
  text-align: left;
  color: rgb(80, 80, 80);
  font-family: "Roboto Light";
}
::v-deep .colorWhite {
  color: black !important;
}
@media only screen and (max-width: 500px) {
  .image {
    padding-top: 5%;
    max-height: 25%;
  }
}
</style>
